import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'

export const NAMESPACE = 'productFollowUp'
const INTERNAL_NAMESPACE = NAMESPACE + '/'

const _types = {
  actions: {
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET: 'RESET'
  }
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    async [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters, asyncProductPool }) {
      await dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters, productFilters, asyncProductPool }, { root: true })
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.RESET_SELECTED_FILTERS, null, { root: true })
    }
  },
  mutations: {
  },
  modules: {
    filters
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/product_follow_up/store/Index.js